"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("./");

var container_1 = require("../container");

var data_1 = require("../data");
/**
 * A single visualization panel allowing a user to select how they wish to view data.
 *
 * @export
 * @extends {React.Component<VizPanelProps, VizPanelState>}
 */


var VizSelectorPanel =
/** @class */
function (_super) {
  __extends(VizSelectorPanel, _super);

  function VizSelectorPanel(props) {
    var _this = _super.call(this, props) || this;

    _this.onVizSelect = function (event, data) {
      _this.setState({
        selectedViz: data.value
      });
    };

    _this.generateDropdownItems = function (supportedVisualizations) {
      return supportedVisualizations.map(function (viz) {
        return {
          key: viz,
          text: viz,
          value: viz
        };
      }).sort(function (a, b) {
        return a.key.localeCompare(b.key);
      });
    };

    _this.state = {
      selectedViz: props.initialViz
    };
    return _this;
  }

  VizSelectorPanel.prototype.render = function () {
    // N.B. We are only setting the width of the VizSelectorPanel, explicitly leaving out the height.
    // This means a component can only grow vertically, but not horizontally, and be correctly styled in containers.
    var _a = this.props,
        data = _a.data,
        supportedVisualizations = _a.supportedVisualizations,
        width = _a.width;
    return React.createElement("div", {
      className: "VizSelectorPanel",
      style: {
        width: width
      }
    }, React.createElement(semantic_ui_react_1.Dropdown, {
      options: this.generateDropdownItems(supportedVisualizations),
      fluid: true,
      onChange: this.onVizSelect,
      defaultValue: this.props.initialViz
    }), React.createElement(semantic_ui_react_1.Card, {
      fluid: true,
      raised: true
    }, this.renderVizContainer(this.state.selectedViz, data)));
  };

  VizSelectorPanel.prototype.renderVizContainer = function (viz, data) {
    var padding = this.props.padding;
    var paddedHeight = this.props.height - padding * 2;
    var paddedWidth = this.props.width - padding * 2;

    switch (viz) {
      case data_1.VIZ_TYPE['T-SNE']:
      case data_1.VIZ_TYPE['TENSOR-T-SNE']:
        return data['TENSOR-T-SNE'] && React.createElement(container_1.TensorTContainer, {
          style: {
            padding: padding
          }
        });

      case data_1.VIZ_TYPE['T-SNE-FRAME']:
        return data['T-SNE'] && React.createElement(component_1.TFrameComponent, {
          data: data['T-SNE'],
          height: paddedHeight,
          padding: padding,
          width: paddedWidth
        });

      case data_1.VIZ_TYPE.SPRING:
        return React.createElement(container_1.SpringContainer, {
          padding: padding
        });

      case data_1.VIZ_TYPE.NGL:
        return data.NGL && React.createElement(component_1.NGLComponent, {
          data: data.NGL,
          height: paddedHeight,
          style: {
            padding: padding
          },
          width: paddedWidth
        });

      case data_1.VIZ_TYPE.CONTACT_MAP:
        return data['Contact Map'] && React.createElement(component_1.PredictedContactMap, {
          data: data['Contact Map'],
          height: paddedHeight,
          style: {
            padding: padding
          },
          width: paddedWidth
        });

      case data_1.VIZ_TYPE.INFO_PANEL:
        return React.createElement(component_1.InfoPanel, {
          data: data['Contact Map'],
          height: 400,
          width: 400
        });

      default:
        throw new Error("Unknown viz: " + viz);
    }
  };

  VizSelectorPanel.defaultProps = {
    data: new Object(),
    height: 450,
    initialViz: data_1.VIZ_TYPE['T-SNE'],
    padding: 15,
    supportedVisualizations: [],
    width: 450
  };
  return VizSelectorPanel;
}(React.Component);

exports.VizSelectorPanel = VizSelectorPanel;